import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { assertPrintFileUri, assertPrintJobName } from "./validate";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OnePrint");
  return hybrid;
}
function isAvailable() {
  return native().isAvailable().catch(rethrowNativeError);
}
function printPdf(fileUri, jobName) {
  assertPrintFileUri(fileUri);
  assertPrintJobName(jobName);
  return native().printPdf(fileUri, jobName).catch(rethrowNativeError);
}
var Print = Object.freeze({
  isAvailable,
  printPdf
});
export {
  Print
};
//# sourceMappingURL=index.native.js.map
